import { gql } from '@apollo/client';

export const ALL_SERVICE_PROVIDER_INTERVENTIONS_FOR_SELECT_INPUT = gql`
  query AllServiceProviderInterventions($input: ExportArgs) {
    interventions: spInterventions(input: $input) {
      id
      name
    }
  }
`;
